import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelListHeaderPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { HotelSnapppayBanner } from "@website/accommodation-ui/hotel-snapppay-banner";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { getChannel } from "@website/utils/channel/get-channel";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { HotelFilterChips } from "@website/widget/filter";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelListHeaderPropertiesType> = (properties) => {
  const router = useRouter();
  const {
    loading,
    totalItem,
    city,
    sortProperties,
    selectedFiltersCount,
    setFilterOpen,
    hasFilter = true,
    hasCityPrefix = true,
    children,
    chipsFiltersSchema,
    clearAllFilters
  } = properties;

  const buttonProperties = {
    variant: "round-outline" as const,
    color: selectedFiltersCount ? ("secondary" as const) : ("neutral" as const),
    size: "small" as const,
    StartIcon: <MaterialIcon className="text-sm" name="tune" />,
    children: selectedFiltersCount
      ? `فیلترها (${numberConvert(selectedFiltersCount, {
          locale: router.locale
        })})`
      : "فیلترها",
    onClick: () => setFilterOpen && setFilterOpen((state) => !state)
  };

  return (
    <>
      <div className="lg:border-outline-thin bg-on-color-high-emphasis -mx-6 flex flex-wrap items-center justify-between gap-2 overflow-auto border border-b-0 p-3 px-5 lg:m-0 lg:overflow-visible lg:rounded-lg lg:border-b lg:bg-transparent lg:px-3">
        <div className="-mt-5 hidden lg:mt-0 lg:block">
          <HotelCityTitle
            city={city}
            hasCityPrefix={hasCityPrefix}
            loading={loading}
            totalItem={totalItem}
          />
        </div>
        <div className="flex justify-start gap-2">
          {hasFilter && (
            <div className="xl:hidden">
              <Button className="!whitespace-nowrap" {...buttonProperties} />
            </div>
          )}
          <HotelSortView {...sortProperties} />
          {children}
          {chipsFiltersSchema && clearAllFilters && (
            <HotelFilterChips
              chipsFiltersSchema={chipsFiltersSchema}
              classname="block md:hidden"
              clearAllFilters={clearAllFilters}
            />
          )}
        </div>
      </div>
      {getChannel() !== "ads" && <HotelSnapppayBanner position="cityPage" />}
    </>
  );
};

export const HotelListHeader = memo(Component, deepCompare);
